import React from 'react';
import TabBar, { TabBarProps } from '../../../../shared/components/TabBar';
import FormContainer from '../Content';

interface TabNavigationProps {
    validated: boolean;
    requiredData: any;
    mergeUser: Function;
}

const TabNavigation = ({ validated, requiredData, mergeUser }: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: 'Thông tin tài khoản',
            content: <FormContainer validated={validated} requiredData={requiredData} mergeUser={mergeUser} />,
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
